import React from "react"
import {
  BrandFacebookIcon,
  BrandInstagramIcon,
  BrandTiktokIcon,
  BrandWhatsappIcon,
  BrandXIcon,
  BrandYoutubeIcon,
} from "@dc-ireland/ui"

export type SocialBrand = "facebook" | "instagram" | "tiktok" | "twitter" | "x" | "whatsapp" | "youtube"

export const SOCIAL_BRAND_LABELS: Record<SocialBrand, string> = {
  facebook: "Facebook",
  instagram: "Instagram",
  tiktok: "TikTok",
  twitter: "X",
  x: "X",
  whatsapp: "WhatsApp",
  youtube: "YouTube",
}

const brandLabels = SOCIAL_BRAND_LABELS

type Props = {
  icons: {
    brand: SocialBrand
    href: string
  }[]
  className?: string
  /** Soft gold hover (brand theme) instead of platform brand colors */
  goldOnHover?: boolean
  /** Show platform name next to each icon */
  showLabels?: boolean
  size?: number
}

const BrandIcon = (brand: SocialBrand, size: number) => {
  const iconProps = { size }

  switch (brand) {
    case "instagram":
      return <BrandInstagramIcon {...iconProps} />
    case "facebook":
      return <BrandFacebookIcon {...iconProps} />
    case "tiktok":
      return <BrandTiktokIcon {...iconProps} />
    case "whatsapp":
      return <BrandWhatsappIcon {...iconProps} />
    case "youtube":
      return <BrandYoutubeIcon {...iconProps} />
    case "x":
    case "twitter":
      return <BrandXIcon {...iconProps} />
  }
}

const SocialIcons: React.FC<Props> = ({
  icons,
  className = "",
  goldOnHover = false,
  showLabels = false,
  size = 30,
}) => {
  if (icons.length === 0) return null

  const hoverClass = goldOnHover ? "hover:text-[#9e7e43]" : "hover:opacity-80"

  return (
    <div className={`inline-flex flex-wrap items-center gap-2.5 ${className}`}>
      {icons.map((icon) => {
        const label = brandLabels[icon.brand]

        if (showLabels) {
          return (
            <a
              key={`${icon.brand}-${icon.href}`}
              target="_blank"
              rel="noopener noreferrer"
              href={icon.href}
              title={label}
              aria-label={label}
              className={`inline-flex items-center gap-2 rounded-full border border-white/15 bg-white/5 px-3.5 py-2 font-dm-sans text-sm font-medium text-inherit backdrop-blur-sm transition hover:border-[#9e7e43]/50 hover:bg-[#9e7e43]/10 ${hoverClass}`}
            >
              {BrandIcon(icon.brand, size)}
              <span>{label}</span>
            </a>
          )
        }

        return (
          <a
            key={`${icon.brand}-${icon.href}`}
            target="_blank"
            rel="noopener noreferrer"
            href={icon.href}
            title={label}
            aria-label={label}
            className={`transform text-inherit transition-colors duration-200 ease-linear active:scale-75 ${hoverClass}`}
          >
            {BrandIcon(icon.brand, size)}
          </a>
        )
      })}
    </div>
  )
}

export default SocialIcons
